import { Box, SxProps, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { FC, ReactElement } from "react";

interface Props {
  text: string;
  icon: ReactElement;
  onClick?: () => void;
  sx?: SxProps<Theme> | undefined;
}
export const IconButton: FC<Props> = React.memo((props) => {
  return (
    <Box sx={{ cursor: "pointer" }} onClick={props.onClick}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          flexDirection: "row",
          marginBottom: "16px",
        }}
      >
        {props.icon}
        <Typography sx={props.sx} variant="body2" pl="8px">
          {props.text}
        </Typography>
      </Box>
    </Box>
  );
});
